import { EntityViewField } from './entity.view';
import { MetadataEntityData, MetadataEntityFieldData, MetadataEntityFieldType, getMetadataEntityFieldType } from '../../../metadata';
import * as Enumerable from 'linq';

export class EntityViewMetadata {

    public readonly highlightable: EntityViewField[];
    public readonly groupable: EntityViewField[];
    public readonly sortable: EntityViewField[];
    public readonly customFields: EntityViewField[];
    public readonly textSearchable: EntityViewField[];

    public readonly card: EntityViewField[];
    public readonly list: EntityViewField[];
    public readonly filters: EntityViewField[];
    public readonly systemFilters: EntityViewField[];

    constructor(
        public readonly metadata: MetadataEntityData
    ) {

        const visibleFields = Enumerable
            .from(metadata?.fields);
        //.where(x => !x.hidden);

        this.highlightable = visibleFields
            .where(x => {
                const type = getMetadataEntityFieldType(x);
                const isDate = type === MetadataEntityFieldType.Date || type === MetadataEntityFieldType.DateTime;
                const isHighlightable = x.highlightable;
                return isDate && isHighlightable;
            })
            .orderBy(x => x.displayName)
            .select(x => this.getViewField(x))
            .toArray();

        this.filters = visibleFields
            .where(x => x.filterable && x.type !== MetadataEntityFieldType.CustomField)
            .select(x => this.getViewField(x))
            .orderBy(x => x.name)
            .toArray();

        this.systemFilters = visibleFields
            .where(x => (x.filterable || x.systemFilterable) && x.type !== MetadataEntityFieldType.CustomField)
            .select(x => this.getViewField(x))
            .orderBy(x => x.name)
            .toArray();

        this.sortable = visibleFields
            .where(x => x.sortable)
            .select(x => this.getViewField(x))
            .orderBy(x => x.name)
            .toArray();

        this.groupable = visibleFields
            .where(x => x.groupable)
            .select(x => this.getViewField(x))
            .orderBy(x => x.name)
            .toArray();

        this.textSearchable = visibleFields
            .where(x => x.textSearchable)
            .select(x => this.getViewField(x))
            .orderBy(x => x.name)
            .toArray();

        this.customFields = visibleFields
            .where(x => x.type === MetadataEntityFieldType.CustomField)
            .select(x => this.getViewField(x))
            .orderBy(x => x.name)
            .toArray();

        this.card = this.list = visibleFields
            .where(x => x.type !== MetadataEntityFieldType.CustomField)
            .select(x => this.getViewField(x))
            .orderBy(x => x.name)
            .toArray();

    }

    public getField(field: string | EntityViewField): MetadataEntityFieldData {

        const fieldName = typeof field === 'string'
            ? field
            : field._id;

        const metadata = this.metadata.fields.find(x => x.name === fieldName);

        return metadata;
    }

    private getViewField(field: MetadataEntityFieldData) {
        return {
            _id: field.name,
            name: field.displayName,
            attributeFilterName: field.attributeFilterName,
            systemHidden: field.hidden,
            visible: !field.hidden,
            moveable: true,
            sortOrder: null
        } as EntityViewField;
    }
}